module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "dotTop"
  }, [_vm._v("Press & Awards")]), _vm._v(" "), _c('div', {
    staticClass: "pressItems"
  }, _vm._l((_vm.pressItems), function(item, index) {
    return _c('press-item', {
      key: index,
      attrs: {
        "item": item
      }
    })
  })), _vm._v(" "), (_vm.expandable) ? _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "button button-color button-yellow",
    on: {
      "click": _vm.toggleExpanded
    }
  }, [_vm._v(_vm._s(_vm.expanded ? 'Show Less' : 'More Press Announcements'))])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-054f3fd9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/about/Press.vue
// module id = 757
// module chunks = 1